<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <CRow v-show="!formVisibility">
          <CCol md="12">
            <CInput
              label="Nama Unit Kerja"
              placeholder="Nama Unit Kerja"
              v-model="form.nama_unit_kerja"
            ></CInput>
            <CInput
              label="No Usulan"
              placeholder="No Usulan"
              v-model="form.no_surat"
            ></CInput>
          </CCol>
        </CRow>
        <CButtonGroup size="sm">
          <CButton color="info" v-show="!formVisibility" @click="loadData()">
            <CIcon name="cil-search" />Cari
          </CButton>
          <CButton color="warning" v-show="!formVisibility" @click="reset()">
            <CIcon name="cil-loop-circular" />Reset
          </CButton>
          <CButton
            color="success"
            @click="formVisibility = !formVisibility"
            v-if="false"
          >
            <CIcon :name="icon_button" />
            {{ button_label }}
          </CButton>
        </CButtonGroup>
        <hr />
        <CCollapse :show="formVisibility">
          <form-input
            @done="resetTabel"
            ref="formInput"
            @clicked="onClickChild"
          />
        </CCollapse>
        <CDataTable
          :items="computedItems"
          :fields="fields"
          hover
          small
          border
          v-show="!formVisibility"
          :loading="loading"
        >
          <template #show_details="{ item, index }">
            <td class="py-2">
              <CButton
                color="primary"
                variant="outline"
                square
                size="sm"
                class="ml-1"
                @click="toggleDetails(item, index)"
                >{{ Boolean(item._toggled) ? "Tutup" : "Verifikasi" }}</CButton
              >
            </td>
          </template>
        </CDataTable>
        <CPagination
          :activePage.sync="page"
          :pages.sync="totalPage"
          size="sm"
          align="end"
          v-show="!formVisibility"
        />
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import formInput from "./form";
import Swal from "sweetalert2";
const fields = [
  { key: "number", label: "No" },
  { key: "no_surat", label: "No. Usulan" },
  { key: "tgl_surat", label: "Tanggal Usulan" },
  { key: "nama_unit_kerja", label: "Unit Kerja" },
  { key: "jumlah_usulan", label: "Jumlah yang Diusulkan" },
  { key: "jumlah_verifikasi", label: "Verifikasi" },
  {
    key: "show_details",
    label: "Action",
    sorter: false,
    filter: false,
  },
];
export default {
  name: "VerifikasiMutasiMasuk",
  components: {
    formInput,
  },
  data() {
    return {
      items: [],
      fields,
      details: [],
      collapseDuration: 0,
      formVisibility: false,
      loading: false,
      page: 1,
      totalPage: 0,
      optionsInstansi: [],
      optionsUnitKerja: [],
      optionsJabatanUmum: [],
      form: {
        nama_unit_kerja: null,
        no_surat: null,
      },
    };
  },
  watch: {
    page: function () {
      this.loadData();
    },
    formVisibility: function (val) {
      if (val) this.$refs.formInput.populateInput(null);
    },
  },
  computed: {
    computedItems() {
      var number = 1;
      let total_pages = 10 * (this.page - 1);
      return this.items.map((item) => {
        var verifikasi = "Menunggu Verifikasi";
        item.pelayanan_detail.map((item) => {
          if (item.status_verifikasi == 1) {
            verifikasi = "Disetujui";
          } else if (item.status_verifikasi == 2) {
            verifikasi = "Berkas Tidak Lengkap";
          } else if (item.status_verifikasi == 3) {
            verifikasi = "Tidak Memenuhi Syarat";
          }
        });
        return {
          ...item,
          number: number++ + total_pages,
          nama_unit_kerja: item.mst_unit_kerja.nama_unit_kerja,
          jumlah_usulan: item.pelayanan_detail.length,
          jumlah_verifikasi: verifikasi,
        };
      });
    },
    title() {
      return this.formVisibility
        ? "Form Usulan Mutasi Masuk"
        : "Tabel Usulan Mutasi Masuk";
    },
    icon_button() {
      return !this.formVisibility ? "cil-plus" : "cil-arrow-left";
    },
    button_label() {
      return !this.formVisibility ? "Tambah" : "Kembali";
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    reset() {
      this.form.nama_unit_kerja = null;
      this.form.no_surat = null;
      this.page = 1;
      this.loadData();
    },
    async loadData() {
      try {
        this.loading = true;
        let data = await this.$store.dispatch("pelayanan/index_mutasi_masuk", {
          page: this.page,
          data: this.form,
        });
        this.items = data.data;
        this.totalPage = data.last_page;
      } catch (ex) {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    delete_item(id) {
      Swal.fire({
        title: "Peringatan!",
        text: "Apa Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Hapus!",
      }).then(async (value) => {
        console.log(value);
        if (value.isConfirmed) {
          await this.$store.dispatch("pelayanan/destroy", id);
          this.loadData();
          Swal.fire({
            title: "Ok!",
            text: "Data berhasil terhapus!",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok!",
          });
        }
      });
    },
    resetTabel() {
      this.$refs.formInput.populateInput(null);
      this.formVisibility = false;
      this.loadData();
    },
    toggleDetails(item) {
      // this.$set(this.items[index], "_toggled", !item._toggled);
      this.formVisibility = true;
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
        this.$refs.formInput.populateInput(item);
      });
    },
    onClickChild() {
      this.formVisibility = !this.formVisibility;
      this.$refs.formInput.populateInput(null);
    },
  },
};
</script>